export default {
  vote: {
    title: "Vote Tally",
    list: {
      empty: "Loading vote",
      header: {
        rank: "Rank",
        account: "Account",
        votePercent: "Vote %",
        decayedVote: "Decayed vote",
        website: "Website"
      },
      legend: {
        runnerUp: "Runner-up",
        runnerUps: "Runner-ups",
        standBy: "Stand-by",
        active: "Active"
      }
    }
  }
}
